import { render } from "./ModalDiningItemsRemoved.vue?vue&type=template&id=1e7c98a4&scoped=true"
import script from "./ModalDiningItemsRemoved.vue?vue&type=script&lang=js"
export * from "./ModalDiningItemsRemoved.vue?vue&type=script&lang=js"

import "./ModalDiningItemsRemoved.vue?vue&type=style&index=0&id=1e7c98a4&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e7c98a4"]])

export default __exports__